<template>
  <v-dialog v-model="dialogShowfriend" persistent max-width="500px">
    <v-card style="border-radius:20px;">
      <v-card tile>
        <v-toolbar card style="background: #1a222c !important;">
          <v-toolbar-title class="white--text CSChatThai" style="white-space: nowrap; width: 100%; overflow: hidden; text-overflow: ellipsis;">
           <span class="headline CSChatThai" >
              <v-icon color="white">group</v-icon>&nbsp;&nbsp;{{$t('Dialog.ShowFriendDialog.header',{groupname: name})}}
              <span style="font-size: 13px;" v-if="member.length !== 0">({{member.length}})</span>
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog">
            <v-icon style="color: white !important; font-size: 25px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important;">
        <v-container grid-list-md>
          <v-layout wrap >
            <v-flex sm4 md4 lg4 xl4 style=" justify-content: center;" v-if="member.length !== 0" v-for="(item, index) in member" >
                <v-layout style=" justify-content: center;display: flex;">
                <v-avatar class="user-photo" >
                  <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle">
                  <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                  <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                  <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                </v-avatar>
              </v-layout>
              <!-- </p> -->
              <p style=" text-align: center;  white-space: nowrap; width: 100%; overflow: hidden; text-overflow: ellipsis;">
                {{item.name}}
              </p>
            </v-flex>
            <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center;"  v-if="member.length == 0">
              {{$t('Dialog.ShowFriendDialog.noMember')}}
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-flex xs9 md9 xl9 lg9>
          <v-layout align-center justify-end row fill-height wrap>
            <v-btn depressed small  class="btnallow" @click="AcceptReq_GroupReq()">
              {{$t('AnswerQuestion.joinGroup')}}
            </v-btn>
          </v-layout>
        </v-flex>
        <v-flex xs3 md3 xl3 lg3 style="margin-left: 1vw;">
          <v-layout align-center justify-start row fill-height wrap>
            <v-btn depressed small class="btncancel" @click="RemoveReq_GroupReq()">
              {{$t('AnswerQuestion.cancel')}}
            </v-btn>
          </v-layout>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// import { mapState } from 'vuex'
import { Decode } from '@/services'
var _ = require('lodash')

export default {
  props: {'dialogShowfriend': false, showgroup: ''},
  data: () => ({
    token: '',
    member: [],
    name: '',
    group_id: '',
    typeuser: '',
    membersGroup: [],
    tokenMember: [],
    businessidMember: [],
    GroupReq: [],
    business_id: '',
    listmember: [],
    usertype: []
  }),
  methods: {
    uppic () {
      $('#uploadpicprofilechat').click()
    },
    closeDialog () {
      this.$emit('closeDialogShowFriend', false)
    },
    AcceptReq_GroupReq () {
      // process.env.APIgo_api + '/v1/accept-group'
      // process.env.APImanage + '/activeinvitegroup'
      this.axios.post(process.env.APIgo_api + '/v1/accept-group', {group_id: this.group_id, tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
          var tokenuser = this.token
          var indexgroup = _.findIndex(response.data.group.member, function (o) { return o.tokenuser === tokenuser })
          if (indexgroup >= 0) {
            this.socketactive_group = {timestamp: response.data.group.member[indexgroup].timestamp_in, groupid: this.group_id, tokenuser: this.token}
          } else {
            this.socketactive_group = {timestamp: '', groupid: this.group_id, tokenuser: this.token}
          }
        }
      })
      this.closeDialog()
    },
    RemoveReq_GroupReq () {
      this.axios.post(process.env.APImanage + '/cancelinvitegroup', {group_id: this.group_id, tokenuser: this.token}).then((response) => {
        if (response.data.status === 'success') {
        }
      })
      this.closeDialog()
    }
  },
  computed: {
  },
  watch: {
    showgroup () {
      this.name = this.showgroup['name']
      this.group_id = this.showgroup['group_id']
      this.membersGroup = this.showgroup['member']
      this.member = _.filter(this.membersGroup, function (member) { return member.statemember === 'active' })
      var pluck = require('lodash.pluck')
      this.axios.post(process.env.APImanage + '/getuser', {owner: this.token, tokenuser: pluck(this.member, 'tokenuser')}).then((response) => {
        this.member = response.data['user']
      })
    }
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  }
}
</script>
<style type="text/css" scoped>
.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #1a75d2 !important;
  color: white !important;
  text-transform: none;
}
.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0vw !important;
  margin-right: 0vw !important;
  background: #242b36 !important;
  color: white !important;
  text-transform: none;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.inputWrapper {
    height: 32px;
    width: 90px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    /*margin-top: 5vh;*/
    /*Using a background color, but you can use a background image to represent a button*/
    /*background-color: #DDF;*/
}
.img {
  display: block;
  max-width:230px;
  max-height:95px;
  width: auto;
  height: auto;
}
.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}
.dialog .dialog--active .dialog--persistent {
  max-height: 107vh;
  overflow: hidden;
}
.card__text {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow: hidden;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
/*.application .theme--light.input-group:not(.input-group--error) label, .theme--light .input-group:not(.input-group--error) label {
  color: #5ed1ff !important;
}*/
</style>



// WEBPACK FOOTER //
// src/components/chat/dialog/manage_group/ShowFriendDialog.vue